import React from 'react';
import { Card, Row, Col, Tag, Typography, Space, Empty } from 'antd';

const { Text } = Typography;

const ActionableInsights = ({ insights }) => {
  if (!insights || insights.length === 0) {
    return (
      <Card title="🎯 Akıllı İçgörüler" style={{ marginBottom: 24 }}>
        <Empty 
          description="Tüm metrikler normal aralıkta görünüyor" 
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      </Card>
    );
  }

  const getInsightColor = (type) => {
    switch(type) {
      case 'error': return '#ff4d4f';
      case 'warning': return '#faad14';
      case 'success': return '#52c41a';
      case 'info': return '#1890ff';
      default: return '#d9d9d9';
    }
  };

  const getPriorityBadge = (priority) => {
    const colors = {
      critical: 'red',
      high: 'orange', 
      medium: 'blue',
      low: 'green'
    };
    
    const labels = {
      critical: 'KRİTİK',
      high: 'YÜKSEK',
      medium: 'ORTA',
      low: 'DÜŞÜK'
    };

    return <Tag color={colors[priority]}>{labels[priority]}</Tag>;
  };

  return (
    <Card 
      title="🎯 Akıllı İçgörüler ve Öneriler" 
      style={{ marginBottom: 24 }}
      extra={
        <Tag color="blue">
          {insights.length} İçgörü
        </Tag>
      }
    >
      <Row gutter={[16, 16]}>
        {insights.map((insight, index) => (
          <Col xs={24} lg={12} key={index}>
            <Card
              size="small"
              style={{ 
                borderLeft: `4px solid ${getInsightColor(insight.type)}`,
                height: '100%'
              }}
            >
              <div style={{ marginBottom: 8 }}>
                <Space>
                  <span style={{ fontSize: '20px' }}>{insight.icon}</span>
                  <Text strong style={{ color: getInsightColor(insight.type) }}>
                    {insight.title}
                  </Text>
                  {getPriorityBadge(insight.priority)}
                </Space>
              </div>
              
              <div style={{ marginBottom: 12 }}>
                <Text>{insight.description}</Text>
              </div>
              
              <div style={{ 
                padding: '8px 12px', 
                backgroundColor: '#f6f6f6', 
                borderRadius: '6px',
                borderLeft: `3px solid ${getInsightColor(insight.type)}`
              }}>
                <Text strong style={{ fontSize: '12px' }}>
                  📋 ÖNERİ: {insight.action}
                </Text>
              </div>
              
              <div style={{ marginTop: 8, textAlign: 'right' }}>
                <Tag>{insight.category}</Tag>
              </div>
            </Card>
          </Col>
        ))}
      </Row>
    </Card>
  );
};

export default React.memo(ActionableInsights);